"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const styles_1 = __importDefault(require("../../styles/styles"));
const pagination_1 = __importDefault(require("../pagination/pagination"));
const ticketCard_1 = __importDefault(require("./ticketCard"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const TicketGridContainer = ({ onPageChange, onTicketPress }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const { tickets, currentPage, totalPages, totalEntries, pageSize } = useAppSelector_1.default((state) => ({
        tickets: state.ticket.tickets,
        currentPage: state.ticket.currentPage,
        totalPages: state.ticket.totalPages,
        totalEntries: state.ticket.totalEntries,
        pageSize: state.ticket.pageSize,
    }));
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, { height: 800 }] },
        react_1.default.createElement(react_native_gesture_handler_1.ScrollView, { showsVerticalScrollIndicator: true },
            react_1.default.createElement(react_native_gesture_handler_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: true, contentContainerStyle: [styles_1.default.flexDirectionColumn, { width: '100%' }] },
                react_1.default.createElement(react_native_1.View, { style: [[styles_1.default.flexDirectionRow, styles_1.default.flexWrap]] }, tickets.map((ticket, index) => (react_1.default.createElement(react_native_1.View, { key: ticket.id, style: [styles_1.default.paddingTen, { flexBasis: isDesktop ? '33%' : '100%' }] },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                        react_1.default.createElement(ticketCard_1.default, { onPress: () => onTicketPress({ ticket, index }), ticket: ticket })))))))),
        react_1.default.createElement(pagination_1.default, { pageSize: pageSize, currentPage: currentPage || 1, totalPages: totalPages || 1, totalEntries: totalEntries || 1, onPageChange: onPageChange })));
};
exports.default = TicketGridContainer;
